/* ==========================================================================
   VastraGharr Luxe - <vg-wishlist-page> (sections/vg-wishlist-page.liquid)
   /collections/all?view=wishlist            -> the shopper's own wishlist
   /collections/all?view=wishlist&items=a,b  -> designs shared with them, with "Save all to my wishlist"
   Cards come from VG.fetchCard (vg-card-fragment); each card gets "Move to bag" with a size choice.
   Needs assets/vg-theme.js (window.VG). Vanilla ES2019.
   ========================================================================== */
(function () {
  'use strict';

  if (customElements.get('vg-wishlist-page')) return;

  var RECENT_KEY = 'vg:recent';
  var uid = 0;

  var CHEVRON =
    '<svg class="vg-wlp__select-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>';
  var CLOSE =
    '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18"/></svg>';
  var ALERT =
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.25"/><path d="M12 7.75v5M12 16h.01"/></svg>';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function plural(count, one, many) {
    return count === 1 ? one : many;
  }

  function cartAddUrl() {
    var root = (window.VG && window.VG.routes && window.VG.routes.root) || '/';
    return root + 'cart/add.js';
  }

  class VgWishlistPage extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.VG = window.VG;
      if (!this.VG || !this.VG.wishlist) return;

      this.grid = this.querySelector('[data-vg-wlp-grid]');
      this.empty = this.querySelector('[data-vg-wlp-empty]');
      this.count = this.querySelector('[data-vg-wlp-count]');
      this.intro = this.querySelector('[data-vg-wlp-intro]');
      this.toolbar = this.querySelector('[data-vg-wlp-toolbar]');
      this.whatsapp = this.querySelector('[data-vg-wlp-whatsapp]');
      this.copyButton = this.querySelector('[data-vg-wlp-copy]');
      this.sharedBox = this.querySelector('[data-vg-wlp-shared]');
      this.sharedTitle = this.querySelector('[data-vg-wlp-shared-title]');
      this.sharedNote = this.querySelector('[data-vg-wlp-shared-note]');
      this.importButton = this.querySelector('[data-vg-wlp-import]');
      this.recentBox = this.querySelector('[data-vg-wlp-recent]');
      this.recentGrid = this.querySelector('[data-vg-wlp-recent-grid]');
      this.titleEl = this.querySelector('[data-vg-wlp-title]');
      this.skeleton = this.querySelector('template[data-vg-wlp-skeleton]');
      this.pageUrl = this.getAttribute('data-page-url') || this.VG.wishlist.pageUrl();
      this.shareMessage = this.getAttribute('data-share-message') || 'Have a look at my wishlist';
      this.showRecent = this.getAttribute('data-show-recent') === 'true';

      this.items = {};
      this.recentRendered = false;
      this.shared = this.readSharedHandles();

      this.onChange = this.onChange.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onSelectChange = this.onSelectChange.bind(this);
      document.addEventListener('vg:wishlist:change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onSelectChange);

      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('vg:wishlist:change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onSelectChange);
    }

    /* ---------- State ---------- */
    readSharedHandles() {
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return null;
      }
      var raw = params.get('items');
      if (!raw) return null;
      var list = this.VG.wishlist.normalise(raw.split(','));
      return list.length ? list : null;
    }

    isShared() {
      return !!this.shared;
    }

    handles() {
      return this.isShared() ? this.shared : this.VG.wishlist.get();
    }

    onChange() {
      this.render();
    }

    /* Header / bottom-nav heart on this page: bring the page itself into view. */
    focusPage() {
      var target = this.titleEl || this;
      target.scrollIntoView({ behavior: this.VG.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      if (typeof target.focus === 'function') target.focus({ preventScroll: true });
    }

    /* ---------- Rendering ---------- */
    render() {
      var handles = this.handles();
      var hasItems = handles.length > 0;
      var own = this.VG.wishlist.get();

      this.updateCount(handles.length);
      this.updateShared(own);
      this.updateShare(own);

      if (this.intro) this.intro.hidden = !hasItems || this.isShared();
      if (this.toolbar) this.toolbar.hidden = this.isShared() || own.length === 0;
      this.grid.hidden = !hasItems;
      this.empty.hidden = hasItems;

      Object.keys(this.items).forEach(
        function (handle) {
          if (handles.indexOf(handle) === -1) this.removeItem(handle);
        }.bind(this)
      );

      handles.forEach(
        function (handle) {
          if (!this.items[handle]) {
            var item = this.createPlaceholder(handle);
            this.items[handle] = item;
            this.grid.appendChild(item);
            this.load(handle, item);
          }
        }.bind(this)
      );

      var order = toArray(this.grid.children)
        .filter(function (el) {
          return !el.classList.contains('is-removing');
        })
        .map(function (el) {
          return el.getAttribute('data-handle');
        });
      if (order.join('|') !== handles.join('|')) {
        handles.forEach(
          function (handle) {
            this.grid.appendChild(this.items[handle]);
          }.bind(this)
        );
      }

      if (!hasItems) this.renderRecent();
    }

    updateCount(count) {
      if (!this.count) return;
      if (this.isShared()) {
        this.count.textContent = count + ' ' + plural(count, 'shared design', 'shared designs');
      } else {
        this.count.textContent = count ? count + ' ' + plural(count, 'saved design', 'saved designs') : '';
      }
    }

    updateShared(own) {
      if (!this.sharedBox) return;
      this.sharedBox.hidden = !this.isShared();
      if (!this.isShared()) return;
      var missing = this.shared.filter(function (handle) {
        return own.indexOf(handle) === -1;
      });
      var total = this.shared.length;
      this.sharedTitle.textContent = total + ' ' + plural(total, 'design was', 'designs were') + ' shared with you';
      if (missing.length) {
        this.sharedNote.textContent =
          missing.length === total
            ? 'Save them to your own wishlist on this device, or move any of them to your bag.'
            : missing.length + ' of them ' + plural(missing.length, 'is', 'are') + ' not in your wishlist yet.';
        this.importButton.hidden = false;
      } else {
        this.sharedNote.textContent = 'All of them are already in your wishlist.';
        this.importButton.hidden = true;
      }
    }

    updateShare(own) {
      var url = own.length ? this.VG.wishlist.shareUrl(own) : '';
      if (this.whatsapp) {
        this.whatsapp.href = url ? 'https://wa.me/?text=' + encodeURIComponent(this.shareMessage + ': ' + url) : 'https://wa.me/';
      }
      if (this.copyButton) this.copyButton.setAttribute('data-vg-copy', url);
    }

    createPlaceholder(handle) {
      var item;
      if (this.skeleton && this.skeleton.content.firstElementChild) {
        item = this.skeleton.content.firstElementChild.cloneNode(true);
      } else {
        item = document.createElement('li');
        item.className = 'grid__item vg-wlp__item vg-wlp__item--loading';
        item.setAttribute('aria-hidden', 'true');
      }
      item.setAttribute('data-handle', handle);
      return item;
    }

    load(handle, item) {
      var page = this;
      this.VG.fetchCard(handle)
        .then(function (html) {
          if (page.items[handle] !== item) return null;
          if (html === null) {
            // The design is no longer in the store.
            if (page.isShared()) page.removeItem(handle);
            else page.VG.wishlist.remove(handle);
            return null;
          }
          return page.VG.prepareCard(html, 'wishlist-page').then(function (content) {
            if (page.items[handle] !== item) return;
            page.fillItem(item, handle, content);
          });
        })
        .catch(function () {
          if (page.items[handle] !== item) return;
          page.fillFallback(item, handle);
        });
    }

    fillItem(item, handle, content) {
      uid += 1;
      var data = null;
      var dataScript = content.querySelector('script[data-vg-card-data]');
      if (dataScript) {
        try {
          data = JSON.parse(dataScript.textContent);
        } catch (e) {
          data = null;
        }
        dataScript.parentNode.removeChild(dataScript);
      }

      // "Move to bag" (with the size choice) replaces the card's own quick add here.
      toArray(content.querySelectorAll('.quick-add')).forEach(function (el) {
        el.parentNode.removeChild(el);
      });

      var wrapper = document.createElement('div');
      wrapper.className = 'shopify-section vg-wlp__card';
      wrapper.id = 'shopify-section-vg-wishlist-page-' + uid;
      wrapper.appendChild(content);

      var heading = wrapper.querySelector('.card__heading');
      var title = (data && data.title) || (heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '');

      item.className = 'grid__item vg-wlp__item';
      item.removeAttribute('aria-hidden');
      item.setAttribute('data-vg-fly-scope', '');
      item.innerHTML = '';
      item.appendChild(wrapper);
      item.appendChild(this.buildBuy(handle, title, data));
      item.appendChild(this.removeButton(handle, title));
      item._vgData = data;
      this.VG.wishlist.sync(item);
    }

    fillFallback(item, handle) {
      item.className = 'grid__item vg-wlp__item vg-wlp__item--fallback';
      item.removeAttribute('aria-hidden');
      item.innerHTML = '';
      var link = document.createElement('a');
      link.className = 'vg-link';
      link.href = this.VG.routes.root + 'products/' + encodeURIComponent(handle);
      link.textContent = 'View design';
      item.appendChild(link);
      item.appendChild(this.removeButton(handle, ''));
    }

    buildBuy(handle, title, data) {
      var box = document.createElement('div');
      box.className = 'vg-wlp__buy';
      var variants = data && Array.isArray(data.variants) ? data.variants : [];
      var available = variants.filter(function (variant) {
        return variant.available;
      });

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--full-width vg-wlp__move';
      button.setAttribute('data-vg-wlp-move', handle);
      button.setAttribute('data-vg-fly-source', 'img');

      if (!data || !available.length) {
        button.disabled = true;
        button.textContent = data ? 'Sold out' : 'Unavailable';
        box.appendChild(button);
        return box;
      }

      if (variants.length > 1) {
        uid += 1;
        var selectId = 'VgWlpSize-' + uid;
        var errorId = selectId + '-error';
        var optionNames = Array.isArray(data.options) ? data.options : [];
        var label = optionNames.length === 1 ? optionNames[0] : optionNames.join(' / ') || 'Option';
        var isSize = optionNames.length && /size/i.test(optionNames[0]);

        var field = document.createElement('div');
        field.className = 'vg-wlp__field';
        var labelEl = document.createElement('label');
        labelEl.className = 'visually-hidden';
        labelEl.setAttribute('for', selectId);
        labelEl.textContent = label + (title ? ' for ' + title : '');
        field.appendChild(labelEl);

        var wrap = document.createElement('div');
        wrap.className = 'vg-wlp__select';
        var select = document.createElement('select');
        select.id = selectId;
        select.className = 'vg-wlp__select-input';
        select.setAttribute('data-vg-wlp-variant', '');
        select.setAttribute('aria-describedby', errorId);

        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = isSize ? 'Select size' : 'Select ' + label.toLowerCase();
        select.appendChild(placeholder);

        variants.forEach(function (variant) {
          var option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.available ? variant.title : variant.title + ' - sold out';
          option.disabled = !variant.available;
          select.appendChild(option);
        });

        // A single in-stock choice needs no decision.
        if (available.length === 1) select.value = String(available[0].id);

        wrap.appendChild(select);
        wrap.insertAdjacentHTML('beforeend', CHEVRON);
        field.appendChild(wrap);

        var error = document.createElement('p');
        error.className = 'vg-field-error';
        error.id = errorId;
        error.hidden = true;
        error.setAttribute('role', 'alert');
        field.appendChild(error);
        box.appendChild(field);
      } else {
        button.setAttribute('data-variant-id', String(available[0].id));
        // Same height as the size picker, so "Move to bag" buttons line up across the row.
        var only = document.createElement('p');
        only.className = 'vg-wlp__single';
        only.textContent = available[0].title && available[0].title !== 'Default Title' ? available[0].title : 'One size';
        box.appendChild(only);
      }

      button.textContent = 'Move to bag';
      box.appendChild(button);
      return box;
    }

    removeButton(handle, title) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vg-wishlist-item__remove vg-wlp__remove';
      button.setAttribute('data-vg-wlp-remove', handle);
      if (this.isShared()) {
        button.hidden = true;
      }
      button.setAttribute('aria-label', title ? 'Remove ' + title + ' from wishlist' : 'Remove from wishlist');
      button.innerHTML = CLOSE + '<span>Remove</span>';
      return button;
    }

    removeItem(handle) {
      var item = this.items[handle];
      delete this.items[handle];
      if (!item) return;
      var cleanup = function () {
        if (item.parentNode) item.parentNode.removeChild(item);
      };
      if (this.VG.prefersReducedMotion() || !item.isConnected) {
        cleanup();
        return;
      }
      item.classList.add('is-removing');
      window.setTimeout(cleanup, 320);
    }

    /* ---------- Recently viewed (empty state) ---------- */
    renderRecent() {
      if (!this.showRecent || !this.recentBox || !this.recentGrid || this.recentRendered) return;
      this.recentRendered = true;
      var own = this.VG.wishlist.get();
      var recent = this.VG.wishlist
        .normalise(this.VG.storage.get(RECENT_KEY, []))
        .filter(function (handle) {
          return own.indexOf(handle) === -1;
        })
        .slice(0, 4);
      if (!recent.length) return;

      var page = this;
      Promise.all(
        recent.map(function (handle) {
          return page.VG.fetchCard(handle)
            .then(function (html) {
              return html ? page.VG.prepareCard(html, 'wishlist-page') : null;
            })
            .catch(function () {
              return null;
            });
        })
      ).then(function (contents) {
        var added = 0;
        contents.forEach(function (content) {
          if (!content) return;
          var script = content.querySelector('script[data-vg-card-data]');
          if (script) script.parentNode.removeChild(script);
          uid += 1;
          var li = document.createElement('li');
          li.className = 'grid__item';
          var wrapper = document.createElement('div');
          wrapper.className = 'shopify-section';
          wrapper.id = 'shopify-section-vg-wishlist-recent-' + uid;
          wrapper.appendChild(content);
          li.appendChild(wrapper);
          page.recentGrid.appendChild(li);
          added += 1;
        });
        if (added) {
          page.recentBox.hidden = false;
          page.VG.wishlist.sync(page.recentGrid);
        }
      });
    }

    /* ---------- Events ---------- */
    onSelectChange(event) {
      var select = event.target;
      if (!select || !select.hasAttribute || !select.hasAttribute('data-vg-wlp-variant')) return;
      this.setError(select, '');
    }

    setError(select, message) {
      var error = document.getElementById(select.getAttribute('aria-describedby'));
      if (message) {
        select.setAttribute('aria-invalid', 'true');
        if (error) {
          error.innerHTML = ALERT + '<span></span>';
          error.lastChild.textContent = message;
          error.hidden = false;
        }
      } else {
        select.removeAttribute('aria-invalid');
        if (error) error.hidden = true;
      }
    }

    onClick(event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var move = target.closest('[data-vg-wlp-move]');
      if (move) {
        event.preventDefault();
        this.moveToBag(move);
        return;
      }

      var remove = target.closest('[data-vg-wlp-remove]');
      if (remove) {
        event.preventDefault();
        this.removeFromWishlist(remove.getAttribute('data-vg-wlp-remove'), remove);
        return;
      }

      if (target.closest('[data-vg-wlp-import]')) {
        event.preventDefault();
        this.importShared();
        return;
      }

      if (target.closest('[data-vg-wlp-clear]')) {
        event.preventDefault();
        this.clearAll();
        return;
      }

      if (target.closest('[data-vg-wlp-whatsapp]')) {
        this.VG.track('share', { method: 'whatsapp', content_type: 'wishlist', item_id: String(this.VG.wishlist.count()) });
      }
    }

    removeFromWishlist(handle, button) {
      if (!handle) return;
      var VG = this.VG;
      this.focusAfterRemove(button);
      VG.wishlist.remove(handle);
      VG.toast('Removed from your wishlist', {
        icon: 'heartOutline',
        action: {
          label: 'Undo',
          onClick: function () {
            VG.wishlist.add(handle);
          },
        },
      });
    }

    focusAfterRemove(element) {
      var item = element && element.closest('.vg-wlp__item');
      if (!item) return;
      var siblings = toArray(this.grid.children);
      var index = siblings.indexOf(item);
      var usable = function (el) {
        return el !== item && !el.classList.contains('is-removing');
      };
      var next = siblings.slice(index + 1).filter(usable)[0] || siblings.slice(0, index).filter(usable).pop() || null;
      var focusTarget = next ? next.querySelector('[data-vg-wlp-remove]:not([hidden]), a[href]') : null;
      var page = this;
      window.setTimeout(function () {
        if (focusTarget && document.contains(focusTarget)) focusTarget.focus();
        else if (page.titleEl) page.titleEl.focus({ preventScroll: false });
      }, 340);
    }

    clearAll() {
      var VG = this.VG;
      var previous = VG.wishlist.get();
      if (!previous.length) return;
      VG.wishlist.set([], { action: 'clear' });
      if (this.titleEl) this.titleEl.focus({ preventScroll: true });
      VG.toast('Wishlist cleared', {
        icon: 'heartOutline',
        duration: 6000,
        action: {
          label: 'Undo',
          onClick: function () {
            VG.wishlist.set(previous, { action: 'restore' });
          },
        },
      });
    }

    importShared() {
      if (!this.shared) return;
      var VG = this.VG;
      var own = VG.wishlist.get();
      var added = this.shared.filter(function (handle) {
        return own.indexOf(handle) === -1;
      });
      var merged = VG.wishlist.normalise(this.shared.concat(own));
      this.shared = null;
      try {
        window.history.replaceState(window.history.state, '', this.pageUrl);
      } catch (e) {
        /* the page still works without the URL update */
      }
      VG.wishlist.set(merged, { action: 'import' });
      VG.track('add_to_wishlist', { items: added.map(function (handle) { return { item_id: handle }; }) });
      VG.toast(
        added.length
          ? 'Saved ' + added.length + ' ' + plural(added.length, 'design', 'designs') + ' to your wishlist'
          : 'These designs are already in your wishlist',
        { icon: 'heart' }
      );
      toArray(this.querySelectorAll('[data-vg-wlp-remove]')).forEach(function (button) {
        button.hidden = false;
      });
      if (this.titleEl) this.titleEl.focus({ preventScroll: true });
    }

    moveToBag(button) {
      if (button.disabled || button.classList.contains('is-loading')) return;
      var item = button.closest('.vg-wlp__item');
      var handle = button.getAttribute('data-vg-wlp-move');
      var variantId = button.getAttribute('data-variant-id');
      var select = item ? item.querySelector('[data-vg-wlp-variant]') : null;

      if (select) {
        variantId = select.value;
        if (!variantId) {
          var data = item._vgData || {};
          var first = Array.isArray(data.options) && data.options[0] ? data.options[0].toLowerCase() : 'size';
          this.setError(select, 'Please select a ' + (/size/.test(first) ? 'size' : 'option') + ' first.');
          select.focus();
          return;
        }
      }
      if (!variantId) return;

      var page = this;
      var VG = this.VG;
      var shared = this.isShared();
      var cart = document.querySelector('cart-drawer');
      var body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
        body.sections_url = window.location.pathname;
      }

      VG.buttonState(button, 'loading');

      fetch(cartAddUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.json().then(function (json) {
            return { ok: response.ok, json: json };
          });
        })
        .then(function (result) {
          if (!result.ok || result.json.status) {
            var error = new Error(result.json.description || result.json.message || 'Could not add to bag');
            error.userMessage = result.json.description || result.json.message;
            throw error;
          }
          var state = result.json;

          if (cart && typeof cart.renderContents === 'function' && state.sections) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(state);
          } else {
            VG.refreshCartCount();
            VG.toast('Added to your bag', {
              icon: 'check',
              action: {
                label: 'View bag',
                onClick: function () {
                  window.location.href = VG.routes.cart;
                },
              },
            });
          }

          if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            window.publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'vg-wishlist-page',
              productVariantId: variantId,
              cartData: state,
              trigger: button,
            });
          }
          VG.dispatch('vg:cart:added', { source: 'vg-wishlist-page', trigger: button, variantId: variantId, items: state.items || [] });
          VG.track('add_to_cart', { items: [{ item_id: handle, item_variant: String(variantId), quantity: 1 }] });

          VG.buttonState(button, 'added', {
            label: 'Added',
            onDone: function () {
              if (shared || page.isShared()) return;
              VG.wishlist.remove(handle);
              VG.toast('Moved to your bag', {
                icon: 'check',
                action: {
                  label: 'Keep saved',
                  onClick: function () {
                    VG.wishlist.add(handle);
                  },
                },
              });
            },
          });
        })
        .catch(function (error) {
          VG.buttonState(button, 'idle');
          var message = (error && error.userMessage) || 'Could not add this design to your bag. Please try again.';
          if (select) page.setError(select, message);
          else VG.toast(message, { icon: 'info', duration: 5000 });
        });
    }
  }

  function define() {
    if (!customElements.get('vg-wishlist-page')) customElements.define('vg-wishlist-page', VgWishlistPage);
  }

  // vg-theme.js (window.VG) is deferred in <head>, so it has run by the time this deferred script executes.
  if (window.VG && window.VG.wishlist) define();
  else document.addEventListener('vg:ready', define, { once: true });
})();
